import { Fragment, useState, useRef } from "react";
import { Dialog, Menu, Transition } from "@headlessui/react";
import { NavLink } from "react-router-dom";
import React, { useEffect } from "react";
import bwipjs from "bwip-js";
import QRCode from "qrcode.react";
import {
  Bars3Icon,
  BellIcon,
  Cog6ToothIcon,
  HomeIcon,
  UsersIcon,
  XMarkIcon,
  CreditCardIcon,
  UserCircleIcon,
  CheckIcon,
  UserPlusIcon,
  EyeIcon,
  BookOpenIcon,
  LockClosedIcon,
  WalletIcon,
  BanknotesIcon,
  CurrencyDollarIcon,
} from "@heroicons/react/24/outline";
import {
  CheckCircleIcon,
  ChevronDownIcon,
  MagnifyingGlassIcon,
} from "@heroicons/react/20/solid";
import useAuth from "../hooks/useAuth";
import Greeting from "./Greeting";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import PaystackPop from "@paystack/inline-js";
import styles from "./styles.module.css";
import html2pdf from "html2pdf.js";
import axios from "axios";
import MyComponent from "./MyComponent";

const teams = [
  { name: "Change Password", to: "/password", icon: LockClosedIcon },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Verify() {
  const [open, setOpen] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const cancelButtonRef = useRef(null);
  const { setAuth, auth, navigate } = useAuth();
  //const history = useHistory();
  const logoutTimer = useRef(null);
  const [qrCodeData, setQRCodeData] = useState("");

  // Function to handle user logout
  const handleLogout = async () => {
    if (hasAdminRole) {
      userTypes = "Administrator";
    } else if (hasEntRole) {
      userTypes = "Enterprise";
    } else if (hasUserRole) {
      userTypes = "User";
    } else if (hasAuditorRole) {
      userTypes = "Auditor";
    } else if (hasUnitRole) {
      userTypes = "Unit Processor";
    }

    const auditTrailData = {
      userId: auth?.user,
      action: "Logout",
      details: {
        ipAddress: userIP, // Use the extracted user's IP address
        userAgent: userAgent,
        country: country,
      },
      status: "Successful",
      usertype: userTypes,
    };
    try {
      const response = await axiosPrivate.post("/auditTrail", auditTrailData);
      /*console.log(
                  "Audit trail entry saved successfully:",
                  response.data
                );*/
    } catch (error) {
      console.error("Error saving audit trail entry:", error);
    }
    setAuth(null);
    localStorage.removeItem("auth"); // Clear auth state from localStorage
    //history.push("/login"); // Redirect to the login page after logout
  };
  useEffect(() => {
    logoutTimer.current = setTimeout(() => {
      handleLogout();
    }, 15 * 60 * 1000); // 15 minutes in milliseconds

    // Reset the timer whenever there's user activity
    const handleUserActivity = () => {
      clearTimeout(logoutTimer.current);
      logoutTimer.current = setTimeout(() => {
        handleLogout();
      }, 15 * 60 * 1000); // 15 minutes in milliseconds
    };

    // Attach event listeners for user activity
    document.addEventListener("mousemove", handleUserActivity);
    document.addEventListener("keydown", handleUserActivity);

    // Clean up event listeners on component unmount
    return () => {
      clearTimeout(logoutTimer.current);
      document.removeEventListener("mousemove", handleUserActivity);
      document.removeEventListener("keydown", handleUserActivity);
    };
  }, []);
  const roles = auth?.roles;
  const enabled = auth.result.enabled;
  const hasAdminRole = roles.includes(5150);
  const hasEntRole = roles.includes(1984);
  const hasUserRole = roles.includes(2001);
  const hasAuditorRole = roles.includes(2023);
  const hasUnitRole = roles.includes(1981);

  const [userIP, setUserIP] = useState("");
  const [country, setCountry] = useState("");
  const [userAgent, setUserAgent] = useState("");

  let userTypes = "";

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await axios.get("https://ipapi.co/json/");
        const data = response.data;
        setUserIP(data.ip); // Extract and set the user's IP address
        setCountry(data.country_name);
        // console.log(data.country_name);
      } catch (error) {
        console.log("Error fetching user data:", error);
      }
    };

    fetchUserData();

    // Get user agent
    setUserAgent(navigator.userAgent);
  }, []);

  const [qrCodeImage, setQRCodeImage] = useState(null);

  const rawNavigation = [
    { name: "Home", to: "/", icon: HomeIcon, current: false },
    { name: "Verify", to: "/verify", icon: CheckIcon, current: true },
    { name: "View Verification", to: "/view", icon: EyeIcon, current: false },
    { name: "Units", to: "/units", icon: CreditCardIcon, current: false },
    { name: "Payments", to: "/payment", icon: WalletIcon, current: false },
    { name: "View Users", to: "/users", icon: UsersIcon, current: false },
    {
      name: "Create User",
      to: "/createuser",
      icon: UserPlusIcon,
      current: false,
    },
    {
      name: "Create Price",
      to: "/createprice",
      icon: BanknotesIcon,
      current: false,
    },
    {
      name: "View Price",
      to: "/price",
      icon: CurrencyDollarIcon,
      current: false,
    },
    {
      name: "API Documentation",
      to: "/documentation",
      icon: BookOpenIcon,
      current: false,
    },
    {
      name: "Change Password",
      to: "/password",
      icon: LockClosedIcon,
      current: false,
    },
    { name: "View Logs", to: "/audit", icon: EyeIcon, current: false },
  ];

  const navigation = rawNavigation.filter((item) => {
    if (item.name === "Units" || item.name === "Payments") {
      // Show 'Units' under specific conditions
      return (
        (auth.result.entID === 1 && hasUserRole) ||
        (auth.result.entID !== 1 && hasEntRole) ||
        (auth.result.entID === 1 && hasAdminRole)
      );
    } else if (
      item.name === "View Users" ||
      item.name === "Create User" ||
      item.name === "API Documentation"
    ) {
      // Only include these items if the user has the Admin or Ent roles
      return hasAdminRole || hasEntRole;
    } else if (item.name === "Create Price" || item.name === "View Price") {
      // Only include these items if the user has the Admin or Ent roles
      return hasAdminRole;
    } else if (item.name === "View Users") {
      // Only include these items if the user has the Unit roles

      return hasUnitRole;
    } else if (item.name === "View Logs") {
      // Only include these items if the user has the Admin or Ent roles

      return hasAdminRole || hasAuditorRole;
    } else {
      // Include all other items
      return true;
    }
  });

  const axiosPrivate = useAxiosPrivate();
  const email = auth?.user;

  const identityOptions = [
    { label: "Choose one", value: "" },
    { label: "Virtual National Identification Number (vNIN)", value: "vnin" },
    { label: "National Identification Number (NIN)", value: "nin" },
    /*
        { label: "Phone", value: "phone" },
    { label: "Demographic", value: "demo" },*/
  ];

  const mailPDF = () => {
    const element = document.getElementById("my-node");
    let opt = {
      margin: 1,
      filename: "verificationresult.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
    };

    html2pdf()
      .set(opt)
      .from(element)
      .output("datauristring")
      .then((dataURL) => {
        let formData = new FormData();
        formData.append("file", dataURItoBlob(dataURL), "myfile.pdf");
        formData.append("email", email);

        axiosPrivate
          .post("/send-email", formData)
          .then((response) => {
            alert("Verification result sent to your email as attachment");
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      });
  };

  function dataURItoBlob(dataURI) {
    var byteString = atob(dataURI.split(",")[1]);
    var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeString });
  }

  const downloadPDF = () => {
    const element = document.getElementById("my-node");

    let opt = {
      margin: 1,
      filename: "verificationresult.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
    };

    html2pdf().set(opt).from(element).save();
  };

  const [data, setData] = useState({
    firstname: "",
    lastname: "",
    phone: "",
    idno: "",
    idtype: "",
    email: email,
    reference: "",
    preference: "",
    gender: "",
    dob: "",
  });

  const [dataurl, setDataurl] = useState("");

  const [img, setImg] = useState("");

  const [isLoading, setIsLoading] = useState(false); // Add isLoading state
  const [ndata, setNdata] = useState(null);
  const [responseData, setResponseData] = useState([]);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState("");
  const [error, setError] = useState("");

  const [showIdno, setShowIdno] = useState(true);
  const [showGender, setShowGender] = useState(false);
  const [showDOB, setShowDOB] = useState(false);
  const [showName, setShowName] = useState(false);
  const [showPhone, setShowPhone] = useState(false);
  const [showLast, setShowLast] = useState(false);

  const handleChange = ({ currentTarget: input }) => {
    setData({ ...data, [input.name]: input.value });

    if (
      input.name === "dob" ||
      input.name === "gender" ||
      input.name === "firstname" ||
      input.name === "lastname"
    ) {
      setShowIdno(false);
      setShowGender(true);
      setShowDOB(true);
      setOpen(false);
    } else if (
      input.name !== "firstname" &&
      input.name !== "lastname" &&
      input.name !== "phone"
    ) {
      switch (input.value) {
        case "vnin":
          setShowIdno(true);
          setShowGender(false);
          setShowDOB(false);
          setShowName(false);
          setShowPhone(false);
          setShowLast(false);
          setOpen(true); // Special logic for vnin
          break;
        case "nin":
          setShowIdno(true);
          setShowGender(false);
          setShowDOB(false);
          setOpen(false);
          setShowName(false);
          setShowPhone(false);
          setShowLast(false);
          break;
        case "phone":
          setShowIdno(false);
          setShowGender(false);
          setShowDOB(false);
          setOpen(false);
          setShowName(false);
          setShowPhone(true);
          setShowLast(false);
          break;
        case "demo":
          setShowIdno(false);
          setShowGender(true);
          setShowDOB(true);
          setOpen(false);
          setShowName(true);
          setShowPhone(false);
          setShowLast(true);
          break;
        default:
          setShowIdno(true);
          setShowGender(false);
          setShowDOB(false);
          setOpen(false);
      }
    }
  };

  const handleClick = () => {
    setPaymentStatus("pay");
  };

  const unitClick = () => {
    setPaymentStatus("unit");
  };
  const [isBusy, setIsBusy] = useState(false); // Add isLoading state

  const handleformSubmit = () => {
    setFormSubmitted(false);
    // Reset other state as needed, for example:
    setNdata(null);
    setError("");
    setQRCodeData("");
    setShowForm(false);
  };
  const [showForm, setShowForm] = useState(false);

  const handleImageClick = (event) => {
    // Extract data from the clicked image's data attributes
    //console.log(event.target.dataset);

    let {
      firstname,
      surname,
      middlename,
      birthdate,
      gender,
      telephoneno,
      photo,
      nin,
    } = event.target.dataset;

    //console.log(telephoneno);

    const codeData = {
      firstname,
      surname,
      middlename,
      birthdate,
      gender,
      telephoneno,
      nin,
    };

    //console.log(codeData);

    // Prepend data:image/png;base64, prefix to the base64 image data
    const base64Image = `data:image/png;base64,${photo}`;

    // Update ndata state with the extracted data including the prefixed photo
    setNdata({
      firstName: firstname,
      surname: surname,
      middleName: middlename,
      dateOfBirth: birthdate,
      gender: gender,
      trustedNumber: telephoneno,
      NIN: nin,
    });
    //const uri = `data:image/png;base64,${qrCodeImage}`;
    //setDataurl(uri);
    //const im = `data:image/png;base64,${res.message.photograph}`;

    // Convert codeData to a JSON string (you can modify this based on your data structure)
    const jsonData = JSON.stringify(codeData);

    // Set the QR code data
    setQRCodeData(jsonData);
    setImg(base64Image);
    setShowForm(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Set isLoading to true when form is submitted
    setError("");

    if (hasAdminRole) {
      userTypes = "Administrator";
    } else if (hasEntRole) {
      userTypes = "Enterprise";
    } else if (hasUserRole) {
      userTypes = "User";
    } else if (hasAuditorRole) {
      userTypes = "Auditor";
    } else if (hasUnitRole) {
      userTypes = "Unit Processor";
    }

    if (!enabled) {
      setError("Your account needs to be enabled before you can verify");
    } else {
      const generateRandomString = () => {
        const length = 6; // set the desired length of the string
        const characters =
          "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789"; // set the allowed characters for the string
        let result = ""; // initialize an empty string

        // loop through the length and add a random character from the allowed characters to the result string
        for (let i = 0; i < length; i++) {
          result += characters.charAt(
            Math.floor(Math.random() * characters.length)
          );
        }

        // return the result string with the word "unit" appended to the end
        return result + "unit";
      };
      if (data.preference !== "") {
        await axiosPrivate.put("/vadmin", {
          reference: data.preference,
          verified: true,
        });
      }

      if (data.idtype === "phone") {
        setNdata({
          firstName: "",
          surname: "",
          middleName: "",
          dateOfBirth: "",
          gender: "",
          trustedNumber: "",
          NIN: "",
        });
        if (paymentStatus === "unit") {
          try {
            const result = await axiosPrivate.post("/useunit", {
              email: email,
            });

            try {
              setIsBusy(true);

              // Step 2: Generate random string and prepare data for the next request
              const randomString = generateRandomString();
              const url = "/searchPhone";
              data.reference = randomString;
              const newData = {
                phone: data.phone,
                idtype: data.idtype,
                email: data.email,
                reference: data.reference,
              };

              // Step 3: Call "/searchPhone" with a timeout
              await axiosPrivate
                .post(url, newData, {
                  timeout: 15000, // 10 seconds timeout for this request
                })
                .then(async (response) => {
                  // Update responseData state with the fetched data
                  //console.log(response);
                  setResponseData(response.data);
                  const auditTrailData = {
                    userId: email,
                    action: "Phone number verification",
                    details: {
                      ipAddress: userIP, // Use the extracted user's IP address
                      userAgent: userAgent,
                      country: country,
                    },
                    status: "Successful",
                    usertype: userTypes,
                  };
                  try {
                    const response = await axiosPrivate.post(
                      "/auditTrail",
                      auditTrailData
                    );
                    /*console.log(
                      "Audit trail entry saved successfully:",
                      response.data
                    );*/
                  } catch (error) {
                    console.error("Error saving audit trail entry:", error);
                  }
                  setData({
                    firstname: "",
                    lastname: "",
                    phone: "",
                    idno: "",
                    idtype: "",
                    email: email,
                    reference: "",
                    preference: "",
                  });
                  setFormSubmitted(true);
                  setShowForm(true);
                })
                .catch((error) => {
                  if (error.response && error.response.status == 500) {
                    const auditTrailData = {
                      userId: email,
                      action: "Phone number verification",
                      details: {
                        ipAddress: userIP, // Use the extracted user's IP address
                        userAgent: userAgent,
                        country: country,
                      },
                      status: "Failed",
                      usertype: userTypes,
                    };
                    try {
                      const response = axiosPrivate.post(
                        "/auditTrail",
                        auditTrailData
                      );
                      /*console.log(
                        "Audit trail entry saved successfully:",
                        response.data
                      );*/
                    } catch (error) {
                      console.error("Error saving audit trail entry:", error);
                    }
                    setError(error.response.data.message);
                  }
                  // Handle errors
                  if (error.code === "ECONNABORTED") {
                    // Handle timeout error
                    setError("Request timed out. Please try again later.");
                  } else if (error.response) {
                    // Handle other response errors
                    const auditTrailData = {
                      userId: email,
                      action: "Phone number verification",
                      details: {
                        ipAddress: userIP, // Use the extracted user's IP address
                        userAgent: userAgent,
                        country: country,
                      },
                      status: "Failed",
                      usertype: userTypes,
                    };
                    try {
                      const response = axiosPrivate.post(
                        "/auditTrail",
                        auditTrailData
                      );
                      /*console.log(
                        "Audit trail entry saved successfully:",
                        response.data
                      );*/
                    } catch (error) {
                      console.error("Error saving audit trail entry:", error);
                    }
                    setError(error.response.data.message);
                  } else {
                    // Handle other errors
                    const auditTrailData = {
                      userId: email,
                      action: "Phone number verification",
                      details: {
                        ipAddress: userIP, // Use the extracted user's IP address
                        userAgent: userAgent,
                        country: country,
                      },
                      status: "Failed",
                      usertype: userTypes,
                    };
                    try {
                      const response = axiosPrivate.post(
                        "/auditTrail",
                        auditTrailData
                      );
                      /*console.log(
                        "Audit trail entry saved successfully:",
                        response.data
                      );*/
                    } catch (error) {
                      console.error("Error saving audit trail entry:", error);
                    }
                    setError("An error occurred. Please try again later.");
                  }
                })
                .finally(() => {
                  setIsBusy(false); // Set isLoading back to false after response is received or request times out
                });
            } catch (error) {
              if (
                error.response &&
                error.response.status >= 400 &&
                error.response.status <= 500
              ) {
                const auditTrailData = {
                  userId: email,
                  action: "Phone number verification",
                  details: {
                    ipAddress: userIP, // Use the extracted user's IP address
                    userAgent: userAgent,
                    country: country,
                  },
                  status: "Failed",
                  usertype: userTypes,
                };
                try {
                  const response = axiosPrivate.post(
                    "/auditTrail",
                    auditTrailData
                  );
                  /*console.log(
                    "Audit trail entry saved successfully:",
                    response.data
                  );*/
                } catch (error) {
                  console.error("Error saving audit trail entry:", error);
                }
                setError(error.response.data.message);
              }
            } finally {
              setIsBusy(false); // Set isLoading back to false after response is received
            }
          } catch (error) {
            if (
              error.response &&
              error.response.status >= 400 &&
              error.response.status <= 500
            ) {
              const auditTrailData = {
                userId: email,
                action: "Phone number verification",
                details: {
                  ipAddress: userIP, // Use the extracted user's IP address
                  userAgent: userAgent,
                  country: country,
                },
                status: "Failed",
                usertype: userTypes,
              };
              try {
                const response = axiosPrivate.post(
                  "/auditTrail",
                  auditTrailData
                );
                /*console.log(
                  "Audit trail entry saved successfully:",
                  response.data
                );*/
              } catch (error) {
                console.error("Error saving audit trail entry:", error);
              }
              setError(error.response.data.message);
            }
          } finally {
            setIsBusy(false); // Set isLoading back to false after response is received
          }
        }
      }
      if (data.idtype === "demo") {
        if (paymentStatus === "unit") {
          //console.log(paymentStatus);
          try {
            const result = await axiosPrivate.post("/useunit", {
              email: email,
            });
            try {
              setIsBusy(true);
              const randomString = generateRandomString();
              const url = "/searchDemo";
              data.reference = randomString;
              // Assuming newData.dob is in the format yyyy-mm-dd (e.g., "2023-10-30")
              const originalDate = new Date(data.dob);
              const day = originalDate.getDate().toString().padStart(2, "0"); // Get day (zero-padded)
              const month = (originalDate.getMonth() + 1)
                .toString()
                .padStart(2, "0"); // Get month (zero-padded)
              const year = originalDate.getFullYear();

              const formattedDate = `${day}-${month}-${year}`;
              //console.log(formattedDate); // Output: "30-10-2023"
              const newData = {
                firstname: data.firstname,
                lastname: data.lastname,
                idtype: data.idtype,
                email: data.email,
                reference: data.reference,
                gender: data.gender,
                dob: data.dob,
              };
              const { data: res } = await axiosPrivate.post(url, newData);
              setNdata(res.message);
              //const uri = `data:image/png;base64,${res.message.barcode}`;
              let {
                firstName,
                surname,
                middleName,
                dateOfBirth,
                gender,
                trustedNumber,
              } = res.message;

              middleName = middleName ? middleName : "";

              const codeData = {
                firstName,
                surname,
                middleName,
                dateOfBirth,
                gender,
                trustedNumber,
              };

              // Convert codeData to a JSON string (you can modify this based on your data structure)
              const jsonData = JSON.stringify(codeData);

              // Set the QR code data
              setQRCodeData(jsonData);
              //setDataurl(uri);
              const im = `data:image/png;base64,${res.message.photograph}`;
              setImg(im);
              const auditTrailData = {
                userId: email,
                action: "Demographic verification",
                details: {
                  ipAddress: userIP, // Use the extracted user's IP address
                  userAgent: userAgent,
                  country: country,
                },
                status: "Successful",
                usertype: userTypes,
              };
              try {
                const response = await axiosPrivate.post(
                  "/auditTrail",
                  auditTrailData
                );
                /*console.log(
                  "Audit trail entry saved successfully:",
                  response.data
                );*/
              } catch (error) {
                console.error("Error saving audit trail entry:", error);
              }
              setData({
                firstname: "",
                lastname: "",
                phone: "",
                idno: "",
                idtype: "",
                email: email,
                reference: "",
                preference: "",
              });

              //console.log(data);
              setFormSubmitted(true);
            } catch (error) {
              if (
                error.response &&
                error.response.status >= 400 &&
                error.response.status <= 500
              ) {
                const auditTrailData = {
                  userId: email,
                  action: "Demographic verification",
                  details: {
                    ipAddress: userIP, // Use the extracted user's IP address
                    userAgent: userAgent,
                    country: country,
                  },
                  status: "Failed",
                  usertype: userTypes,
                };
                try {
                  const response = axiosPrivate.post(
                    "/auditTrail",
                    auditTrailData
                  );
                } catch (error) {
                  console.error("Error saving audit trail entry:", error);
                }
                setError(error.response.data.message);
              }
            } finally {
              setIsBusy(false); // Set isLoading back to false after response is received
            }
          } catch (error) {
            if (
              error.response &&
              error.response.status >= 400 &&
              error.response.status <= 500
            ) {
              const auditTrailData = {
                userId: email,
                action: "Demographic verification",
                details: {
                  ipAddress: userIP, // Use the extracted user's IP address
                  userAgent: userAgent,
                  country: country,
                },
                status: "Failed",
                usertype: userTypes,
              };
              try {
                const response = axiosPrivate.post(
                  "/auditTrail",
                  auditTrailData
                );
              } catch (error) {
                console.error("Error saving audit trail entry:", error);
              }
              setError(error.response.data.message);
            }
          } finally {
            setIsBusy(false); // Set isLoading back to false after response is received
          }
        }
      }

      if (data.idtype === "nin") {
        if (paymentStatus === "unit") {
          //console.log(paymentStatus);
          try {
            const result = await axiosPrivate.post("/useunit", {
              email: email,
            });
            try {
              setIsBusy(true);
              const randomString = generateRandomString();
              const url = "/nin";
              data.reference = randomString;
              //console.log(data);
              //console.log(transaction.reference);

              const newData = {
                idno: data.idno,
                idtype: data.idtype,
                email: data.email,
                reference: data.reference,
              };
              const { data: res } = await axiosPrivate.post(url, newData);
              setNdata(res.message);
              //const uri = `data:image/png;base64,${res.message.barcode}`;
              let {
                firstName,
                surname,
                middleName,
                dateOfBirth,
                gender,
                trustedNumber,
              } = res.message;

              middleName = middleName ? middleName : "";

              const codeData = {
                firstName,
                surname,
                middleName,
                dateOfBirth,
                gender,
                trustedNumber,
              };

              // Convert codeData to a JSON string (you can modify this based on your data structure)
              const jsonData = JSON.stringify(codeData);

              // Set the QR code data
              setQRCodeData(jsonData);
              //setDataurl(uri);
              const im = `data:image/png;base64,${res.message.photograph}`;
              setImg(im);
              const auditTrailData = {
                userId: email,
                action: "NIN verification",
                details: {
                  ipAddress: userIP, // Use the extracted user's IP address
                  userAgent: userAgent,
                  country: country,
                },
                status: "Successful",
                usertype: userTypes,
              };
              try {
                const response = await axiosPrivate.post(
                  "/auditTrail",
                  auditTrailData
                );
              } catch (error) {
                console.error("Error saving audit trail entry:", error);
              }
              setData({
                firstname: "",
                lastname: "",
                phone: "",
                idno: "",
                idtype: "",
                email: email,
                reference: "",
                preference: "",
              });

              //console.log(data);
              setFormSubmitted(true);
            } catch (error) {
              if (
                error.response &&
                error.response.status >= 400 &&
                error.response.status <= 500
              ) {
                const auditTrailData = {
                  userId: email,
                  action: "NIN verification",
                  details: {
                    ipAddress: userIP, // Use the extracted user's IP address
                    userAgent: userAgent,
                    country: country,
                  },
                  status: "Failed",
                  usertype: userTypes,
                };
                try {
                  const response = axiosPrivate.post(
                    "/auditTrail",
                    auditTrailData
                  );
                } catch (error) {
                  console.error("Error saving audit trail entry:", error);
                }
                setError(error.response.data.message);
              }
            } finally {
              setIsBusy(false); // Set isLoading back to false after response is received
            }
          } catch (error) {
            if (
              error.response &&
              error.response.status >= 400 &&
              error.response.status <= 500
            ) {
              const auditTrailData = {
                userId: email,
                action: "NIN verification",
                details: {
                  ipAddress: userIP, // Use the extracted user's IP address
                  userAgent: userAgent,
                  country: country,
                },
                status: "Failed",
                usertype: userTypes,
              };
              try {
                const response = axiosPrivate.post(
                  "/auditTrail",
                  auditTrailData
                );
              } catch (error) {
                console.error("Error saving audit trail entry:", error);
              }
              setError(error.response.data.message);
            }
          } finally {
            setIsBusy(false); // Set isLoading back to false after response is received
          }
        }
      }
      if (data.idtype === "vnin") {
        if (paymentStatus === "unit") {
          //console.log(paymentStatus);
          try {
            const result = await axiosPrivate.post("/useunit", {
              email: email,
            });
            try {
              setIsBusy(true);
              const randomString = generateRandomString();
              const url = "/verify";
              data.reference = randomString;
              //console.log(data);
              //console.log(transaction.reference);
              const newData = {
                idno: data.idno,
                idtype: data.idtype,
                email: data.email,
                reference: data.reference,
              };
              const { data: res } = await axiosPrivate.post(url, newData);
              setNdata(res.message);
              let {
                firstName,
                surname,
                middleName,
                dateOfBirth,
                gender,
                trustedNumber,
              } = res.message;

              const codeData = {
                firstName,
                surname,
                middleName,
                dateOfBirth,
                gender,
                trustedNumber,
              };

              // Convert codeData to a JSON string (you can modify this based on your data structure)
              const jsonData = JSON.stringify(codeData);

              // Set the QR code data
              setQRCodeData(jsonData);
              const im = `data:image/png;base64,${res.message.photograph}`;
              setImg(im);
              const auditTrailData = {
                userId: email,
                action: "VNIN verification",
                details: {
                  ipAddress: userIP, // Use the extracted user's IP address
                  userAgent: userAgent,
                  country: country,
                },
                status: "Successful",
                usertype: userTypes,
              };
              try {
                const response = await axiosPrivate.post(
                  "/auditTrail",
                  auditTrailData
                );
              } catch (error) {
                console.error("Error saving audit trail entry:", error);
              }
              setData({
                firstname: "",
                lastname: "",
                phone: "",
                idno: "",
                idtype: "",
                email: email,
                reference: "",
                preference: "",
              });

              //console.log(data);
              setFormSubmitted(true);
            } catch (error) {
              if (
                error.response &&
                error.response.status >= 400 &&
                error.response.status <= 500
              ) {
                const auditTrailData = {
                  userId: email,
                  action: "VNIN verification",
                  details: {
                    ipAddress: userIP, // Use the extracted user's IP address
                    userAgent: userAgent,
                    country: country,
                  },
                  status: "Failed",
                  usertype: userTypes,
                };
                try {
                  const response = axiosPrivate.post(
                    "/auditTrail",
                    auditTrailData
                  );
                } catch (error) {
                  console.error("Error saving audit trail entry:", error);
                }
                setError(error.response.data.message);
              }
            } finally {
              setIsBusy(false); // Set isLoading back to false after response is received
            }
          } catch (error) {
            if (
              error.response &&
              error.response.status >= 400 &&
              error.response.status <= 500
            ) {
              const auditTrailData = {
                userId: email,
                action: "VNIN verification",
                details: {
                  ipAddress: userIP, // Use the extracted user's IP address
                  userAgent: userAgent,
                  country: country,
                },
                status: "Failed",
                usertype: userTypes,
              };
              try {
                const response = axiosPrivate.post(
                  "/auditTrail",
                  auditTrailData
                );
              } catch (error) {
                console.error("Error saving audit trail entry:", error);
              }
              setError(error.response.data.message);
            }
          } finally {
            setIsBusy(false); // Set isLoading back to false after response is received
          }
        }
      }
    }
  };

  useEffect(() => {
    if (qrCodeImage) {
      // Use the updated qrCodeImage here
      const uri = `data:image/png;base64,${qrCodeImage.toString("base64")}`;
      setDataurl(uri);
      console.log(qrCodeImage);
    }
  }, [qrCodeImage]); // useEffect will trigger when qrCodeImage changes

  return (
    <>
      <div>
        <Transition.Root show={open} as={Fragment}>
          <Dialog
            as="div"
            className="relative z-50"
            initialFocus={cancelButtonRef}
            onClose={setOpen}
          >
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <div className="fixed inset-0 z-10 overflow-y-auto">
              <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                    <button
                      className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
                      onClick={() => setOpen(false)}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                    </button>
                    <div className="w-full items-start justify-start flex flex-col px-12 pt-12 pb-6">
                      <h1 className="font-bold text-xl xl:text-2xl pb-2 ">
                        {" "}
                        Verification{" "}
                      </h1>
                      <p className="text-md font-bold text-red-500">NOTICE</p>

                      <div className="pt-5">
                        <h4 className="text-2xl pb-3">Generating a vNIN</h4>
                        <p>There are two ways to generate a virtual NIN:</p>
                      </div>
                      <div className="pt-5 text-2xl flex">
                        <svg width="41" height="40" fill="none">
                          <g
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2.75"
                            clipPath="url(#ussdhint_svg__a)"
                          >
                            <path d="M26.666 6.667H13.333c-.92 0-1.667.746-1.667 1.666v23.334c0 .92.747 1.666 1.667 1.666h13.333c.921 0 1.667-.746 1.667-1.666V8.333c0-.92-.746-1.666-1.666-1.666zm-8.332 1.666h3.333m-1.667 20v.017"></path>
                          </g>
                          <path fill="#fff" d="M20 15h21v10H20z"></path>
                          <path
                            fill="#262626"
                            d="M22.29 17.682l-.137 1.305 1.313-.372.102.728-1.227.11.797 1.062-.663.359-.578-1.145-.516 1.142-.69-.356.789-1.063-1.22-.113.116-.724 1.289.372-.137-1.305h.762zM26.511 23h-.806v-3.216c0-.107 0-.214.003-.322l.007-.314c.004-.103.01-.2.017-.294-.048.052-.107.11-.178.17a11.13 11.13 0 01-.219.192l-.574.458-.403-.509 1.483-1.162h.67V23zm5.028 0h-3.384v-.605l1.296-1.313c.25-.255.457-.475.618-.66.162-.186.282-.363.36-.529.079-.166.119-.347.119-.543 0-.242-.07-.424-.209-.547-.139-.126-.322-.188-.55-.188-.216 0-.417.043-.602.13a2.795 2.795 0 00-.567.362l-.44-.53c.138-.118.286-.227.444-.325a2.289 2.289 0 011.203-.321c.316 0 .59.057.82.171a1.237 1.237 0 01.718 1.169c0 .269-.054.517-.16.745-.108.228-.26.454-.459.677-.198.22-.434.461-.707.721l-.865.844v.038h2.365V23zm3.814-3.855c0 .225-.045.421-.136.587a1.158 1.158 0 01-.376.41c-.157.105-.34.18-.547.226v.024c.399.05.7.175.902.376.205.2.308.466.308.796 0 .29-.07.549-.209.776a1.4 1.4 0 01-.639.534c-.287.13-.656.194-1.107.194a4.06 4.06 0 01-.755-.065 2.791 2.791 0 01-.657-.208v-.714a3.24 3.24 0 001.357.328c.417 0 .715-.078.892-.233.178-.157.267-.373.267-.65a.667.667 0 00-.14-.437c-.091-.114-.234-.199-.428-.256a2.66 2.66 0 00-.741-.085h-.441v-.646h.444c.29 0 .522-.035.697-.103a.767.767 0 00.38-.29.774.774 0 00.12-.431c0-.214-.07-.38-.209-.5-.139-.12-.345-.18-.619-.18-.168 0-.322.019-.461.058a2.085 2.085 0 00-.38.147 3.664 3.664 0 00-.331.191l-.386-.557c.189-.141.414-.26.676-.359a2.61 2.61 0 01.916-.147c.513 0 .908.11 1.187.332.278.218.416.512.416.881zm3.883.875l-.191.977h.923v.57h-1.033L38.66 23h-.609l.28-1.432h-.854L37.206 23h-.595l.264-1.432h-.855v-.57h.964l.195-.979h-.906v-.57h1.008l.274-1.443h.608l-.273 1.443h.861l.277-1.443h.591l-.273 1.443h.861v.57h-.97zm-1.65.977h.854l.195-.977h-.858l-.192.977z"
                          ></path>
                          <defs>
                            <clipPath id="ussdhint_svg__a">
                              <path fill="#fff" d="M0 0h40v40H0z"></path>
                            </clipPath>
                          </defs>
                        </svg>{" "}
                        <h4>Via USSD</h4>
                      </div>
                      <ul className="pt-5">
                        <li className="pl-20 pt-3">
                          To generate a Virtual NIN via USSD, dial <br />
                          <span className="text-green-700">
                            *996*3*Your NIN*{process.env.REACT_APP_CODE}#
                          </span>
                        </li>
                        <li className="pl-20 pt-3">
                          An SMS message will be sent back to you containing the
                          Virtual NIN generated for you.
                        </li>
                      </ul>
                      <div className="pt-5 text-2xl flex">
                        <svg width="40" height="40" fill="none">
                          <g
                            stroke="#2C3E50"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2.75"
                            clipPath="url(#apphint_svg__a)"
                          >
                            <path d="M26.666 6.667H13.333c-.92 0-1.667.746-1.667 1.666v23.334c0 .92.747 1.666 1.667 1.666h13.333c.921 0 1.667-.746 1.667-1.666V8.333c0-.92-.746-1.666-1.666-1.666zm-8.332 1.666h3.333m-1.667 20v.017"></path>
                          </g>
                          <defs>
                            <clipPath id="apphint_svg__a">
                              <path fill="#fff" d="M0 0h40v40H0z"></path>
                            </clipPath>
                          </defs>
                        </svg>{" "}
                        <h4>Through the NIMC app</h4>
                      </div>
                      <ul className="pt-5">
                        <li className="pl-20 pt-3">
                          Download the NIMC App- Click on "Get Virtual NIN"
                        </li>
                        <li className="pl-20 pt-3">
                          Select "Input Enterprise short-code" and type
                          {process.env.REACT_APP_CODE}
                        </li>
                        <li className="pl-20 pt-3">
                          Click "Submit" and your virtual NIN will be generated.
                        </li>
                      </ul>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
        <Transition.Root show={sidebarOpen} as={Fragment}>
          <Dialog
            as="div"
            className="relative z-50 lg:hidden"
            onClose={setSidebarOpen}
          >
            <Transition.Child
              as={Fragment}
              enter="transition-opacity ease-linear duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="transition-opacity ease-linear duration-300"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-900/80" />
            </Transition.Child>

            <div className="fixed inset-0 flex">
              <Transition.Child
                as={Fragment}
                enter="transition ease-in-out duration-300 transform"
                enterFrom="-translate-x-full"
                enterTo="translate-x-0"
                leave="transition ease-in-out duration-300 transform"
                leaveFrom="translate-x-0"
                leaveTo="-translate-x-full"
              >
                <Dialog.Panel className="relative mr-16 flex w-full max-w-xs flex-1">
                  <Transition.Child
                    as={Fragment}
                    enter="ease-in-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in-out duration-300"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                  >
                    <div className="absolute left-full top-0 flex w-16 justify-center pt-5">
                      <button
                        type="button"
                        className="-m-2.5 p-2.5"
                        onClick={() => setSidebarOpen(false)}
                      >
                        <span className="sr-only">Close sidebar</span>
                        <XMarkIcon
                          className="h-6 w-6 text-white"
                          aria-hidden="true"
                        />
                      </button>
                    </div>
                  </Transition.Child>
                  {/* Sidebar component, swap this element with another sidebar if you like */}
                  <div className="flex grow flex-col gap-y-5 overflow-y-auto bg-white px-6 pb-4">
                    <div className="flex h-16 shrink-0 items-center mt-4">
                      <img className="logo w-auto" src="logo.png" alt="" />
                    </div>
                    <nav className="flex flex-1 flex-col">
                      <ul role="list" className="flex flex-1 flex-col gap-y-7">
                        <li>
                          <ul role="list" className="-mx-2 space-y-1">
                            {navigation.map((item) => (
                              <li key={item.name}>
                                <NavLink
                                  to={item.to}
                                  className={classNames(
                                    item.current
                                      ? "bg-gray-50 text-blue-600"
                                      : "text-gray-700 hover:text-blue-600 hover:bg-gray-50",
                                    "group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold"
                                  )}
                                >
                                  <item.icon
                                    className={classNames(
                                      item.current
                                        ? "text-blue-600"
                                        : "text-gray-400 group-hover:text-blue-600",
                                      "h-6 w-6 shrink-0"
                                    )}
                                    aria-hidden="true"
                                  />
                                  {item.name}
                                </NavLink>
                              </li>
                            ))}
                          </ul>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </Dialog>
        </Transition.Root>

        {/* Static sidebar for desktop */}
        <div className="hidden lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:w-72 lg:flex-col">
          {/* Sidebar component, swap this element with another sidebar if you like */}
          <div className="flex grow flex-col gap-y-5 overflow-y-auto border-r border-gray-200 bg-white px-6 pb-4">
            <div className="flex h-16 shrink-0 items-center mt-4">
              <img className="logo w-auto" src="logo.png" alt="" />
            </div>
            <nav className="flex flex-1 flex-col">
              <ul role="list" className="flex flex-1 flex-col gap-y-7">
                <li>
                  <ul role="list" className="-mx-2 space-y-1">
                    {navigation.map((item) => (
                      <li key={item.name}>
                        <NavLink
                          to={item.to}
                          className={classNames(
                            item.current
                              ? "bg-gray-50 text-blue-600"
                              : "text-gray-700 hover:text-blue-600 hover:bg-gray-50",
                            "group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold"
                          )}
                        >
                          <item.icon
                            className={classNames(
                              item.current
                                ? "text-blue-600"
                                : "text-gray-400 group-hover:text-blue-600",
                              "h-6 w-6 shrink-0"
                            )}
                            aria-hidden="true"
                          />
                          {item.name}
                        </NavLink>
                      </li>
                    ))}
                  </ul>
                </li>
              </ul>
            </nav>
          </div>
        </div>

        <div className="lg:pl-72">
          <div className="sticky top-0 z-40 lg:mx-auto lg:max-w-7xl lg:px-8">
            <div className="flex h-16 items-center gap-x-4 border-b border-gray-200 bg-white px-4 shadow-sm sm:gap-x-6 sm:px-6 lg:px-0 lg:shadow-none">
              <button
                type="button"
                className="-m-2.5 p-2.5 text-gray-700 lg:hidden"
                onClick={() => setSidebarOpen(true)}
              >
                <span className="sr-only">Open sidebar</span>
                <Bars3Icon className="h-6 w-6" aria-hidden="true" />
              </button>

              {/* Separator */}
              <div
                className="h-6 w-px bg-gray-200 lg:hidden"
                aria-hidden="true"
              />

              <div className="flex flex-1 gap-x-4 self-stretch lg:gap-x-6 border-b-2 border-blue-400">
                <form className="relative flex flex-1" action="#" method="GET">
                  <label htmlFor="search-field" className="sr-only">
                    Search
                  </label>
                </form>
                <div className="flex items-center gap-x-4 lg:gap-x-6">
                  <button
                    type="button"
                    className="-m-2.5 p-2.5 text-blue-400 hover:text-blue-500"
                  >
                    <span className="sr-only">View notifications</span>
                    <BellIcon className="h-6 w-6" aria-hidden="true" />
                  </button>

                  {/* Separator */}
                  <div
                    className="hidden lg:block lg:h-6 lg:w-px lg:bg-blue-200"
                    aria-hidden="true"
                  />

                  {/* Profile dropdown */}
                  <Menu as="div" className="relative">
                    <Menu.Button className="-m-1.5 flex items-center p-1.5">
                      <span className="sr-only">Open user menu</span>
                      <UserCircleIcon
                        className="h-8 w-8 rounded-full text-blue-400"
                        aria-hidden="true"
                      />
                      <span className="hidden lg:flex lg:items-center">
                        <span
                          className="ml-4 text-sm font-semibold leading-6 text-gray-900"
                          aria-hidden="true"
                        >
                          {auth.result.firstName} {auth.result.lastName}
                        </span>
                        <ChevronDownIcon
                          className="ml-2 h-5 w-5 text-blue-400"
                          aria-hidden="true"
                        />
                      </span>
                    </Menu.Button>
                    <Transition
                      as={Fragment}
                      enter="transition ease-out duration-100"
                      enterFrom="transform opacity-0 scale-95"
                      enterTo="transform opacity-100 scale-100"
                      leave="transition ease-in duration-75"
                      leaveFrom="transform opacity-100 scale-100"
                      leaveTo="transform opacity-0 scale-95"
                    >
                      <Menu.Items className="absolute right-0 z-10 mt-2.5 w-32 origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none">
                        <Menu.Item>
                          {({ active }) => (
                            <NavLink
                              to="/password"
                              className={classNames(
                                active ? "bg-gray-100" : "",
                                "block px-4 py-2 text-sm text-gray-700"
                              )}
                            >
                              Your Password
                            </NavLink>
                          )}
                        </Menu.Item>

                        <Menu.Item>
                          {({ active }) => (
                            <a
                              onClick={handleLogout}
                              className={classNames(
                                active ? "bg-gray-100" : "",
                                "block px-4 py-2 text-sm text-gray-700"
                              )}
                            >
                              Logout
                            </a>
                          )}
                        </Menu.Item>
                      </Menu.Items>
                    </Transition>
                  </Menu>
                </div>
              </div>
            </div>
          </div>

          <main className="py-10">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
              <div className="bg-white shadow border-b-2 border-blue-400">
                <div className="px-4 sm:px-6 lg:mx-auto lg:max-w-6xl lg:px-8">
                  <div className="py-6 md:flex md:items-center md:justify-between lg:border-t lg:border-blue-400">
                    <div className="min-w-0 flex-1">
                      {/* Profile */}
                      <div className="flex items-center">
                        <UserCircleIcon
                          className="hidden h-16 w-16 rounded-full sm:block"
                          aria-hidden="true"
                        />
                        <div>
                          <div className="flex items-center">
                            <UserCircleIcon
                              className="hidden h-16 w-16 rounded-full sm:hidden"
                              aria-hidden="true"
                            />
                            <h1 className="ml-3 text-2xl font-bold leading-7 text-gray-900 sm:truncate sm:leading-9">
                              <Greeting />, {auth.result.firstName}{" "}
                              {auth.result.lastName}
                            </h1>
                          </div>
                          <dl className="mt-6 flex flex-col sm:ml-3 sm:mt-1 sm:flex-row sm:flex-wrap">
                            <dt className="sr-only">Account status</dt>
                            <dd className="mt-3 flex items-center text-sm font-medium capitalize text-blue-500 sm:mr-6 sm:mt-0">
                              <CheckCircleIcon
                                className="mr-1.5 h-5 w-5 flex-shrink-0 text-blue-400"
                                aria-hidden="true"
                              />
                              Verified account
                            </dd>
                          </dl>
                        </div>
                      </div>
                    </div>
                    <div className="mt-6 flex space-x-3 md:ml-4 md:mt-0">
                      <MyComponent auth={auth} roles={roles} />
                    </div>
                  </div>
                </div>
              </div>

              {!formSubmitted && !showForm ? (
                <>
                  <div className="mt-8">
                    <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
                      <form
                        className="space-y-6 w-full px-6"
                        onSubmit={handleSubmit}
                      >
                        <div className="grid grid-cols-1 gap-x-8 gap-y-10 border-b border-gray-900/10 pb-12 md:grid-cols-3">
                          <div>
                            <h2 className="text-base font-semibold leading-7 text-gray-900">
                              Verification Request
                            </h2>
                            <p className="mt-1 text-sm leading-6 text-gray-600">
                              Provide information about who you want verified
                            </p>
                          </div>

                          <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                            <div className="col-span-full">
                              <label
                                htmlFor="idtype"
                                className="text-gray-700 text-lg font-bold"
                              >
                                Identity Type
                              </label>
                              <div className="mt-2">
                                <select
                                  name="idtype"
                                  id="idtype"
                                  onChange={handleChange}
                                  value={data.idtype}
                                  className="mt-1 h-12 block w-full pl-4 border-2 border-gray-300 rounded-md shadow-sm focus:border-blue-300 focus:ring focus:ring-blue-200 focus:ring-opacity-50"
                                  required
                                >
                                  {identityOptions.map((option) => (
                                    <option
                                      key={option.value}
                                      value={option.value}
                                    >
                                      {option.label}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            {showName && (
                              <div className="sm:col-span-3">
                                <label
                                  htmlFor="first-name"
                                  className="text-gray-700 text-lg font-bold"
                                >
                                  First name
                                </label>
                                <div className="mt-2">
                                  <input
                                    type="text"
                                    name="firstname"
                                    onChange={handleChange}
                                    value={data.firstname}
                                    id="firstname"
                                    autoComplete="given-name"
                                    className="mt-1 h-12 block w-full pl-4 border-2 border-gray-300 rounded-md shadow-sm focus:border-blue-300 focus:ring focus:ring-blue-200 focus:ring-opacity-50"
                                    placeholder="First Name"
                                  />
                                </div>
                              </div>
                            )}
                            {showLast && (
                              <div className="sm:col-span-3">
                                <label
                                  htmlFor="last-name"
                                  className="text-gray-700 text-lg font-bold"
                                >
                                  Last name
                                </label>
                                <div className="mt-2">
                                  <input
                                    type="text"
                                    name="lastname"
                                    id="lastname"
                                    onChange={handleChange}
                                    value={data.lastname}
                                    autoComplete="family-name"
                                    className="mt-1 h-12 block w-full pl-4 border-2 border-gray-300 rounded-md shadow-sm focus:border-blue-300 focus:ring focus:ring-blue-200 focus:ring-opacity-50"
                                    placeholder="Last Name"
                                  />
                                </div>
                              </div>
                            )}

                            {showPhone && (
                              <div className="col-span-full">
                                <label
                                  htmlFor="phone"
                                  className="text-gray-700 text-lg font-bold"
                                >
                                  Phone number
                                </label>
                                <div className="mt-2">
                                  <input
                                    type="number"
                                    name="phone"
                                    id="phone"
                                    onChange={handleChange}
                                    value={data.phone}
                                    autoComplete="phone-number"
                                    className="mt-1 h-12 block w-full pl-4 border-2 border-gray-300 rounded-md shadow-sm focus:border-blue-300 focus:ring focus:ring-blue-200 focus:ring-opacity-50"
                                    placeholder="Phone"
                                  />
                                </div>
                              </div>
                            )}

                            {showIdno && (
                              <div className="col-span-full">
                                <label
                                  htmlFor="idno"
                                  className="text-gray-700 text-lg font-bold"
                                >
                                  Identification Number
                                </label>
                                <div className="mt-2">
                                  <input
                                    type="text"
                                    name="idno"
                                    id="idno"
                                    onChange={handleChange}
                                    value={data.idno}
                                    autoComplete="identity-no"
                                    className="mt-1 h-12 block w-full pl-4 border-2 border-gray-300 rounded-md shadow-sm focus:border-blue-300 focus:ring focus:ring-blue-200 focus:ring-opacity-50"
                                    required
                                    placeholder="Identification Number"
                                  />
                                </div>
                              </div>
                            )}
                            {showGender && (
                              <div className="sm:col-span-3">
                                <label
                                  htmlFor="gender"
                                  className="text-gray-700 text-lg font-bold"
                                >
                                  Gender
                                </label>
                                <div className="mt-2">
                                  <select
                                    name="gender"
                                    id="gender"
                                    onChange={handleChange}
                                    value={data.gender}
                                    className="mt-1 h-12 block w-full pl-4 border-2 border-gray-300 rounded-md shadow-sm focus:border-blue-300 focus:ring focus:ring-blue-200 focus:ring-opacity-50"
                                    required
                                  >
                                    <option value="">Select a Gender</option>
                                    <option value="M">Male</option>
                                    <option value="F">Female</option>
                                  </select>
                                </div>
                              </div>
                            )}
                            {showDOB && (
                              <div className="sm:col-span-3">
                                <label
                                  htmlFor="dob"
                                  className="text-gray-700 text-lg font-bold"
                                >
                                  Date of Birth
                                </label>
                                <div className="mt-2">
                                  <input
                                    type="date"
                                    name="dob"
                                    id="dob"
                                    onChange={handleChange}
                                    value={data.dob}
                                    className="mt-1 h-12 block w-full pl-4 border-2 border-gray-300 rounded-md shadow-sm focus:border-blue-300 focus:ring focus:ring-blue-200 focus:ring-opacity-50"
                                    required
                                  />
                                </div>
                              </div>
                            )}
                            <div className="col-span-full">
                              {error && (
                                <div
                                  className={"w-full px-2 " + styles.error_msg}
                                >
                                  {error}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="mt-6 flex items-center justify-end gap-x-6">
                          {isBusy ? (
                            <button
                              disabled
                              type="button"
                              className="h-12 px-6 text-white bg-blue-500 rounded-lg hover:bg-blue-400 focus:outline-none flex-1 mr-1"
                            >
                              Verifying ...
                            </button>
                          ) : (
                            <button
                              onClick={unitClick}
                              type="submit"
                              className="h-12 px-6 text-white bg-blue-500 rounded-lg hover:bg-blue-400 focus:outline-none flex-1 mr-1"
                            >
                              Verify with Unit
                            </button>
                          )}
                        </div>
                      </form>
                    </div>
                  </div>
                </>
              ) : null}

              {formSubmitted && !showForm ? (
                <>
                  <div className="mt-8">
                    <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
                      <div className="grid grid-cols-1 gap-x-8 gap-y-10 border-b border-gray-900/10 pb-12 md:grid-cols-3">
                        <div></div>

                        <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                          <div
                            id="my-node"
                            className="md:flex items-start justify-start w-full lg:space-y-0 space-y-4 lg:space-x-4 px-12 flex flex-col"
                          >
                            <div className="bg-white flex flex-col items-center justify-start px-4 w-[600px] h-[600px] shadow-md">
                              <div className="flex items-center justify-center w-full">
                                <div
                                  className="bg-white shadow-lg rounded-lg overflow-hidden relative border-2 border-gray-300"
                                  style={{ width: "550px", height: "300px" }} // Add border styling here
                                >
                                  {/* Coat of Arms Placeholder */}
                                  <img
                                    className="h-8 w-8 absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
                                    src="coatofarms.png"
                                    alt="Coat of Arms"
                                    style={{ marginTop: "30px" }}
                                  />

                                  <div
                                    className="px-6 py-8"
                                    style={{ marginTop: "15px" }}
                                  >
                                    <div className="flex justify-between">
                                      <div className="flex">
                                        {/* User Image Placeholder - Made square */}
                                        <img
                                          className="h-32 w-32  mr-4"
                                          src={img}
                                          alt="User Photo"
                                          style={{ objectFit: "cover" }}
                                        />
                                        <div className="text-left">
                                          {/* Name and Details Placeholder */}
                                          <div className="text-sm font-bold">
                                            Surname/Nom
                                          </div>
                                          <div className="text-sm mb-2">
                                            {ndata.surname}
                                          </div>
                                          <div className="text-sm font-bold">
                                            Given Names/Prénoms
                                          </div>
                                          <div className="text-sm mb-2">
                                            {ndata.firstName},{" "}
                                            {ndata.middleName}
                                          </div>
                                          <div className="flex justify-start">
                                            <div className="mr-6">
                                              <div className="text-sm font-bold">
                                                Date of Birth
                                              </div>
                                              <div className="text-sm">
                                                {ndata.dateOfBirth}
                                              </div>
                                            </div>
                                            <div>
                                              <div className="text-sm font-bold">
                                                Sex/Sexe
                                              </div>
                                              <div className="text-sm">
                                                {ndata.gender}
                                              </div>
                                            </div>
                                          </div>
                                          <div className="text-sm mb-2">
                                            <span className="font-bold">
                                              Telephone:
                                            </span>{" "}
                                            {ndata.trustedNumber}
                                          </div>
                                        </div>
                                      </div>
                                      <div className="text-center">
                                        {/* NGA Text above QR Code */}
                                        <div className="text-xs font-bold mb-1">
                                          NGA
                                        </div>
                                        {/* QR Code Placeholder 
                  <img
                    className="h-32 w-32"
                    src="https://via.placeholder.com/128/000000/FFFFFF/?text=QR+Code"
                    alt="QR Code"
                  />*/}
                                        {qrCodeData && (
                                          <div className="w-32 h-32">
                                            <QRCode value={qrCodeData} />
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                    {ndata.NIN && (
                                      <div className="text-center">
                                        {/* NIN Number Placeholder */}
                                        <div className="text-sm font-bold">
                                          National Identification Number (NIN)
                                        </div>
                                        <div className="text-4xl font-bold">
                                          {ndata.NIN}
                                        </div>
                                      </div>
                                    )}
                                    <div className="flex items-center justify-center">
                                      <img
                                        src="nimc.png"
                                        alt="Logo"
                                        className="h-6 w-auto mr-2"
                                      />
                                      <div className="text-xs font-bold">
                                        Verified at National Identity Management
                                        Commission
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="bg-white shadow-lg rounded-lg overflow-hidden relative border-2 border-gray-300"
                                style={{ width: "550px", height: "300px" }} // Add border styling here
                              >
                                <div className="p-8">
                                  <div className="flex flex-col items-center justify-center h-full">
                                    <p className="text-xl font-bold text-center mb-4">
                                      Disclaimer
                                    </p>
                                    <p className="text-base font-semibold text-center">
                                      Trust, but verify.
                                    </p>
                                    <p className="text-base text-center px-4">
                                      While every effort has been made to ensure
                                      the accuracy of the verification process,
                                      it is important to note that it may not be
                                      100% foolproof. The verification result
                                      should be considered as an indication of
                                      verification status rather than an
                                      absolute guarantee.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Back of the card */}
                          </div>
                        </div>
                        <div></div>
                        <div className="border-t border-gray-200 w-full my-4 pt-4 flex flex-col justify-center items-center">
                          <button onClick={downloadPDF}>Download PDF</button>
                          <button onClick={mailPDF}>Email PDF</button>
                          <button
                            onClick={handleformSubmit}
                            type="button"
                            className="w-60 h-12 px-6 text-white bg-green-500 rounded-lg hover:bg-green-600 focus:outline-none ml-1"
                          >
                            Back to verification
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ) : null}
              {formSubmitted && showForm ? (
                <>
                  <div className="mt-8">
                    <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
                      <div className="flex flex-wrap">
                        {responseData.map((data, index) => (
                          <div
                            key={index}
                            className="flex flex-col items-center m-2"
                          >
                            <img
                              src={`data:image/png;base64,${data.photo[0]}`}
                              alt={`Person ${index + 1}`}
                              className="w-32 h-32 cursor-pointer"
                              data-firstname={data.firstname[0]}
                              data-surname={data.surname[0]}
                              data-middlename={
                                data.middlename && data.middlename[0]
                                  ? data.middlename[0]
                                  : ""
                              }
                              data-birthdate={data.birthdate[0]}
                              data-gender={data.gender[0]}
                              data-telephoneno={data.telephoneno[0]}
                              data-photo={data.photo[0]}
                              data-nin={data.nin[0]}
                              onClick={handleImageClick}
                            />
                            <div className="mt-2">
                              <div>{data.firstname[0]} </div>
                              {data.middlename && data.middlename[0] && (
                                <div>{data.middlename[0]}</div>
                              )}
                              <div>{data.surname[0]}</div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </>
              ) : null}
            </div>
          </main>
        </div>
      </div>
    </>
  );
}
